import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const ChevronDownIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="ChevronDownIcon" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/chevron/down">
            <path fill="none" d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </g>
    </SvgIcon>
)
